import ArrowRight from './arrowRight.svg?react';
import ArrowDown from './arrowDown.svg?react';
import ArrowUp from './arrowUp.svg?react';
import Battery from './battery.svg?react';
import BatteryLow from './batteryLow.svg?react';
import Bin from './bin.svg?react';
import Box from './box.svg?react';
import BubbleChart from './bubbleChart.svg?react';
import Business from './business.svg?react';
import CheckMark from './checkMark.svg?react';
import Circle from './circle.svg?react';
import CircleMarker from './circleMarker.svg?react';
import Company from './company.svg?react';
import Copy from './copy.svg?react';
import CropFree from './cropFree.svg?react';
import Desktop from './desktop.svg?react';
import Download from './download.svg?react';
import Edit from './edit.svg?react';
import Equalizer from './equalizer.svg?react';
import Error from './error.svg?react';
import ErrorGray from './errorGray.svg?react';
import ErrorOutline from './errorOutline.svg?react';
import FavoriteBorder from './favoriteBorder.svg?react';
import Heart from './heart.svg?react';
import Hills from './hills.svg?react';
import Infrastructure from './infrastructure.svg?react';
import IntersectingBubbleChart from './intersectingBubbleChart.svg?react';
import Label from './label.svg?react';
import MarkerDrag from './markerDrag.svg?react';
import Minus from './minus.svg?react';
import Notifications from './notifications.svg?react';
import PanTool from './panTool.svg?react';
import Phone from './phone.svg?react';
import Plus from './plus.svg?react';
import Polygon from './polygon.svg?react';
import PowerSettings from './powerSettings.svg?react';
import Question from './question.svg?react';
import Schedule from './schedule.svg?react';
import Shape from './shape.svg?react';
import Shield from './shieldExclamation.svg?react';
import ShieldQuestion from './shieldQuestion.svg?react';
import ShieldCrossedOut from './shieldCrossedOut.svg?react';
import Shortcut from './shortcut.svg?react';
import Smartphone from './smartphone.svg?react';
import Texture from './texture.svg?react';
import Timer from './timer.svg?react';
import TrendingDown from './trendingDown.svg?react';
import Unlink from './unlink.svg?react';
import WarningAmber from './warningAmber.svg?react';
import Whatshot from './whatshot.svg?react';
import ZoomIn from './zoomIn.svg?react';
import Lock from './lock.svg?react';
import ArrowsExpandLeft from './arrowsExpandLeft.svg?react';
import CompressRight from './compressRight.svg?react';
import Info from './info.svg?react';
import Replay from './replay.svg?react';
import Translate from './translate.svg?react';
import Scale from './scale.svg?react';
import EnteringDangerZone from './enteringDangerZone.svg?react';
import LeaveDangerZone from './leaveDangerZone.svg?react';
import SoundOn from './soundOn.svg?react';
import SoundOff from './soundOff.svg?react';
import Charging from './charging.svg?react';
import BatteryLowAlert from './batteryLowAlert.svg?react';
import SOS from './sos.svg?react';
import Fall from './fall.svg?react';
import ImmobilizedFall from './immobilizedFall.svg?react';
import CameraDrag from './CameraDrag.svg?react';
import Camera from './Camera.svg?react';
import Pin from './pin.svg?react';
import PlaceMarkerDrag from './placeMarkerDrag.svg?react';
import Layers from './layers.svg?react';
import StartMarker from './startMarker.svg?react';
import FinishMarker from './finishMarker.svg?react';
import Floppy from './floppy.svg?react';
import Person from './person.svg?react';
import PersonOutline from './personOutline.svg?react';
import ShieldNormal from './shield.svg?react';
import List from './list.svg?react';
import Catalog from './catalog.svg?react';
import Applications from './applications.svg?react';
import Users from './users.svg?react';
import Areas from './areas.svg?react';
import InfrastructureIcon from './infrastructureIcon.svg?react';
import CameraIcon from './cameraIcon.svg?react';

export type IIcon =
  | 'arrowRight'
  | 'arrowDown'
  | 'arrowUp'
  | 'battery'
  | 'batteryLow'
  | 'bin'
  | 'box'
  | 'bubbleChart'
  | 'business'
  | 'checkMark'
  | 'circle'
  | 'circleMarker'
  | 'company'
  | 'copy'
  | 'cropFree'
  | 'desktop'
  | 'download'
  | 'edit'
  | 'equalizer'
  | 'error'
  | 'errorGray'
  | 'errorOutline'
  | 'favoriteBorder'
  | 'heart'
  | 'hills'
  | 'infrastructure'
  | 'intersectingBubbleChart'
  | 'label'
  | 'markerDrag'
  | 'minus'
  | 'notifications'
  | 'panTool'
  | 'phone'
  | 'plus'
  | 'polygon'
  | 'powerSettings'
  | 'question'
  | 'schedule'
  | 'shape'
  | 'shield'
  | 'shieldQuestion'
  | 'shieldCrossedOut'
  | 'shortcut'
  | 'smartphone'
  | 'texture'
  | 'timer'
  | 'trendingDown'
  | 'unlink'
  | 'warningAmber'
  | 'whatshot'
  | 'zoomIn'
  | 'lock'
  | 'arrowsExpandLeft'
  | 'compressRight'
  | 'info'
  | 'replay'
  | 'translate'
  | 'scale'
  | 'enteringDangerZone'
  | 'leaveDangerZone'
  | 'soundOn'
  | 'soundOff'
  | 'charging'
  | 'batteryLowAlert'
  | 'sos'
  | 'fall'
  | 'immobilizedFall'
  | 'cameraDrag'
  | 'camera'
  | 'pin'
  | 'placeMarkerDrag'
  | 'layers'
  | 'startMarker'
  | 'finishMarker'
  | 'floppy'
  | 'person'
  | 'personOutline'
  | 'shieldNormal'
  | 'list'
  | 'applications'
  | 'catalog'
  | 'users'
  | 'areas'
  | 'infrastructureIcon'
  | 'cameraIcon';

type IIcons = Record<IIcon, React.FunctionComponent<React.SVGProps<SVGSVGElement>>>;

const icons: IIcons = {
  arrowRight: ArrowRight,
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  battery: Battery,
  batteryLow: BatteryLow,
  bin: Bin,
  box: Box,
  bubbleChart: BubbleChart,
  business: Business,
  checkMark: CheckMark,
  circle: Circle,
  circleMarker: CircleMarker,
  company: Company,
  copy: Copy,
  cropFree: CropFree,
  desktop: Desktop,
  download: Download,
  edit: Edit,
  equalizer: Equalizer,
  error: Error,
  errorGray: ErrorGray,
  errorOutline: ErrorOutline,
  favoriteBorder: FavoriteBorder,
  heart: Heart,
  hills: Hills,
  infrastructure: Infrastructure,
  intersectingBubbleChart: IntersectingBubbleChart,
  label: Label,
  markerDrag: MarkerDrag,
  minus: Minus,
  notifications: Notifications,
  panTool: PanTool,
  phone: Phone,
  plus: Plus,
  polygon: Polygon,
  powerSettings: PowerSettings,
  question: Question,
  schedule: Schedule,
  shape: Shape,
  shield: Shield,
  shieldQuestion: ShieldQuestion,
  shieldCrossedOut: ShieldCrossedOut,
  shortcut: Shortcut,
  smartphone: Smartphone,
  texture: Texture,
  timer: Timer,
  trendingDown: TrendingDown,
  unlink: Unlink,
  warningAmber: WarningAmber,
  whatshot: Whatshot,
  zoomIn: ZoomIn,
  lock: Lock,
  arrowsExpandLeft: ArrowsExpandLeft,
  compressRight: CompressRight,
  info: Info,
  replay: Replay,
  translate: Translate,
  scale: Scale,
  enteringDangerZone: EnteringDangerZone,
  leaveDangerZone: LeaveDangerZone,
  soundOn: SoundOn,
  soundOff: SoundOff,
  charging: Charging,
  batteryLowAlert: BatteryLowAlert,
  sos: SOS,
  fall: Fall,
  immobilizedFall: ImmobilizedFall,
  cameraDrag: CameraDrag,
  camera: Camera,
  pin: Pin,
  placeMarkerDrag: PlaceMarkerDrag,
  layers: Layers,
  startMarker: StartMarker,
  finishMarker: FinishMarker,
  floppy: Floppy,
  person: Person,
  personOutline: PersonOutline,
  shieldNormal: ShieldNormal,
  list: List,
  catalog: Catalog,
  applications: Applications,
  users: Users,
  areas: Areas,
  infrastructureIcon: InfrastructureIcon,
  cameraIcon: CameraIcon
};

export default icons;
